/** Best-effort resolution of the wall footprint image S3 key for a solution. */
export function getSolutionImageKey(solution) {
    if (!solution)
        return undefined;
    if (solution.image)
        return solution.image;
    const assets = solution.assets;
    if (!assets)
        return undefined;
    const preferred = assets['wall.png'] || assets['image'];
    if (preferred)
        return preferred;
    return Object.values(assets).find(value => typeof value === 'string' && value.toLowerCase().endsWith('.png'));
}
export const REPRESENTATION_ORDER = [
    'plan',
    'elevation',
    'section',
    'detail',
    '3d'
];
export const REPRESENTATION_LABELS = {
    plan: 'Plan',
    elevation: 'Elevation',
    section: 'Section',
    detail: 'Detail',
    '3d': '3D'
};
/** Flattens the grouped representations into an ordered, labelled chip list. */
export function buildRepresentationChips(reps) {
    if (!reps)
        return [];
    const chips = [];
    REPRESENTATION_ORDER.forEach(viewType => {
        const list = reps[viewType];
        if (!(list === null || list === void 0 ? void 0 : list.length))
            return;
        list.forEach((rep, index) => {
            const base = REPRESENTATION_LABELS[viewType];
            chips.push({
                id: rep.representationID,
                label: list.length === 1 ? base : `${base} ${index + 1}`,
                imageKey: rep.image,
                jsonKey: rep.json,
                viewType
            });
        });
    });
    return chips;
}
/**
 * Ordered image gallery for a solution: representation PNGs first (in view-type order),
 * then the wall footprint image (`wall.png`) last, skipping it if already present.
 */
export function buildSolutionGallery(solution) {
    if (!solution)
        return [];
    const items = buildRepresentationChips(solution.representations).map(({ id, label, imageKey, jsonKey }) => ({ id, label, imageKey, jsonKey }));
    const wallKey = getSolutionImageKey(solution);
    if (wallKey && !items.some(item => item.imageKey === wallKey)) {
        items.push({ id: 'wall', label: 'Wall', imageKey: wallKey });
    }
    return items;
}
